import React, { FC, useState } from 'react'
import Button from '../../../common/Button/Button'
import Rate from '../../../common/Rate/Rate'
import ReviewForm from '../../../forms/ReviewForm/ReviewForm'
import AsideModal from '../../../modals/AsideModal'
import Review from '../../../review/Review/Review'
import { ButtonTheme, IProductDetail, IReview } from '../../../types'
import css from './ProductReviews.module.scss'
import LoadingIcon from '../../../../public/static/icons/form-loader.svg'
import MediaSlider from '../../../review/MediaSlider'
import MediaSliderProvider from '../../../../contexts/mediaSliderProvider'
import ReviewDetailContainer from '../../../modals/ReviewDetail/ReviewDetailContainer'
import ReviewDetailProvider from '../../../../contexts/ReviewDetailProvider'
import MaxWidth from '../../../layout/MaxWidth/MaxWidth'

interface IProductReviews {
  reviews: IReview[]
  product: IProductDetail
  loadingReviews: boolean
}

const ProductReviews: FC<IProductReviews> = ({
  reviews,
  product,
  loadingReviews,
}) => {
  const [openForm, setOpenForm] = useState(false)
  const [showAllReviews, setShowAllReviews] = useState(false)

  if (!product) {
    return null
  }

  return (
    <MaxWidth className={css.wrapper} id="product-reviews">
      <div className={css.top}>
        <div className={css.titleWrapper}>
          <h3 className={css.title}>Отзывы о товаре</h3>
          <p className={css.subtitle}>все отзывы от проверенных покупателей</p>
        </div>
        <div className={css.rate}>
          {product.rate && reviews?.length > 0 && (
            <div className={css.rate_container}>
              <span className={css.rate_num}>{product.rate.toFixed(1)}</span>
              <Rate big rate={product.rate} />
            </div>
          )}

          {reviews?.length < 1 && (
            <p className={css.reviewsEmpty}>
              У этого товара еще нет отзывов. Будьте первым кто оставит отзыв!
            </p>
          )}

          <Button
            onClick={() => setOpenForm(true)}
            theme={ButtonTheme.ellipseMedium}
          >
            Оставить отзыв
          </Button>
        </div>
      </div>
      <MediaSliderProvider productId={product.id}>
        <MediaSlider className={css.media} />
      </MediaSliderProvider>
      {loadingReviews ? (
        <LoadingIcon />
      ) : (
        <>
          <ul className={css.reviews}>
            {reviews
              ?.slice(0, !showAllReviews ? 3 : reviews.length)
              ?.map((review, index) => {
                return <Review key={index} review={review} isProduct />
              })}
          </ul>

          {reviews?.length > 3 && !showAllReviews && (
            <Button
              onClick={() => setShowAllReviews(true)}
              className={css.showAll}
              theme={ButtonTheme.ellipseMedium}
            >
              Все отзывы
            </Button>
          )}
        </>
      )}
      <AsideModal open={openForm} onClose={() => setOpenForm(false)}>
        <ReviewForm
          onClose={() => setOpenForm(false)}
          productId={product?.id}
        />
      </AsideModal>
      <ReviewDetailProvider productId={product?.id}>
        <ReviewDetailContainer />
      </ReviewDetailProvider>
    </MaxWidth>
  )
}

export default ProductReviews
